import Component from '@glimmer/component';
import { formatInTimeZone } from 'date-fns-tz';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';
import { DATE_FNS_12_HOUR_TIME, formatDateTimeInSystemTimezone } from 'garaje/utils/date-fns-tz-utilities';

interface TimeCellSignature {
  Args: {
    time: Date | null;
    locationTimezone: string;
  };
}

export default class TimeCell extends Component<TimeCellSignature> {
  get locationTime(): string {
    if (!this.args.time) return 'N/A';
    return formatInTimeZone(this.args.time, this.args.locationTimezone, DATE_FNS_12_HOUR_TIME);
  }

  get dateTimeInSystemTimezone(): string {
    if (!this.args.time) return 'N/A';
    return formatDateTimeInSystemTimezone(this.args.time);
  }

  <template>
    <div class="flex">
      <div class="flex flex-col">
        {{#if @time}}
          <EmberTooltip @side="top-start" @text={{this.dateTimeInSystemTimezone}} />
        {{/if}}
        <span data-test-time>{{this.locationTime}}</span>
      </div>
    </div>
  </template>
}
